import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { getCachedScript } from "../../utils/scriptCache.js";
import handleClick from "../../utils/handleClick.js";
import Modal from "../Modal/Modal";
import MogrtGroupItem from "./MogrtGroupItem";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { v4 as uuidv4 } from "uuid";
import "./CreateGroup.css";

const DND_ITEM_TYPE = "ITEM";
const DND_GROUP_TYPE = "GROUP";

const DEV_CONTROLLERS = "[{\"name\":\"Explainer Intro - Explainer Intro Scene 2\",\"controllers\":[{\"name\":\"Global Position\",\"id\":8851,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"1920,1080,0\",\"layerType\":\"other\",\"comp\":\"Handle Explainer Intro Scene 2 Control\",\"compId\":8849,\"parentFolder\":\"Mogrt Control\",\"offline\":false},{\"name\":\"Global Size\",\"id\":8851,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"other\",\"comp\":\"Handle Explainer Intro Scene 2 Control\",\"compId\":8849,\"parentFolder\":\"Mogrt Control\",\"offline\":false},{\"name\":\"Global Rotation\",\"id\":8851,\"propertyType\":{\"type\":3,\"capPropType\":5},\"value\":\"0\",\"layerType\":\"other\",\"comp\":\"Handle Explainer Intro Scene 2 Control\",\"compId\":8849,\"parentFolder\":\"Mogrt Control\",\"offline\":false},{\"name\":\"BG\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.88696658611298,0.72549021244049,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Text 1\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.12156863510609,0.12156863510609,0.12156863510609,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Text 2\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"1,1,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 1\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.12156863510609,0.12156863510609,0.12156863510609,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 2\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"1,1,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 3\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.79215693473816,0.79215693473816,0.79215693473816,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 4\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.35294118523598,0.35294118523598,0.35294118523598,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 5\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.83921575546265,0.68627452850342,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 6\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"1,0.89019614458084,0.74901962280273,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 7\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"1,0.80392163991928,0.96078437566757,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Element 8\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.8156863451004,0.82352948188782,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Color gradient 1\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.94117647409439,0.40784314274788,0.81960785388947,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Color gradient 2\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.51460218429565,0.34509804844856,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Color gradient 3\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"0.14117661118507,0,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Color gradient 4\",\"id\":6733,\"propertyType\":{\"type\":4,\"capPropType\":3},\"value\":\"1,1,1,1\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"3D Element 1\",\"id\":6733,\"propertyType\":{\"type\":3,\"capPropType\":5},\"value\":\"0\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"3D Element 2\",\"id\":6733,\"propertyType\":{\"type\":3,\"capPropType\":5},\"value\":\"0\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"3D Element 3\",\"id\":6733,\"propertyType\":{\"type\":3,\"capPropType\":5},\"value\":\"0\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"3D Element 4\",\"id\":6733,\"propertyType\":{\"type\":3,\"capPropType\":5},\"value\":\"0\",\"layerType\":\"controls\",\"comp\":\"Explainer Intro Scene 2\",\"compId\":6719,\"parentFolder\":\"Color\",\"offline\":false},{\"name\":\"Image 1\",\"id\":6761,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 1\",\"compId\":244,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Image 2\",\"id\":6774,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 2\",\"compId\":970,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Image 3\",\"id\":6787,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 3\",\"compId\":984,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Image 4\",\"id\":6800,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 4\",\"compId\":998,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Image 5\",\"id\":6813,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 5\",\"compId\":1012,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Image 6\",\"id\":6826,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 6\",\"compId\":1026,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Image 7\",\"id\":6839,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 7\",\"compId\":1040,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Image 8\",\"id\":6852,\"propertyType\":{\"type\":14,\"capPropType\":11},\"value\":\"\",\"layerType\":\"media\",\"comp\":\"Image 8\",\"compId\":1054,\"parentFolder\":\"Image\",\"offline\":false},{\"name\":\"Text_10 - Text\",\"id\":843,\"propertyType\":{\"type\":6,\"capPropType\":0},\"value\":\"Select your video\",\"layerType\":\"text\",\"comp\":\"Text_10\",\"compId\":841,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_10 - Position\",\"id\":843,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"714.5,82,0\",\"layerType\":\"text\",\"comp\":\"Text_10\",\"compId\":841,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_10 - Size\",\"id\":843,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"text\",\"comp\":\"Text_10\",\"compId\":841,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_10 - Line Spacing\",\"id\":843,\"propertyType\":{\"type\":2,\"capPropType\":1},\"value\":\"0\",\"layerType\":\"text\",\"comp\":\"Text_10\",\"compId\":841,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_11 - Text\",\"id\":4357,\"propertyType\":{\"type\":6,\"capPropType\":0},\"value\":\"Empowering workflows\",\"layerType\":\"text\",\"comp\":\"Text_11\",\"compId\":4249,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_11 - Position\",\"id\":4357,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"1239.560546875,231.005966186523,0\",\"layerType\":\"text\",\"comp\":\"Text_11\",\"compId\":4249,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_11 - Size\",\"id\":4357,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"text\",\"comp\":\"Text_11\",\"compId\":4249,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_11 - Line Spacing\",\"id\":4357,\"propertyType\":{\"type\":2,\"capPropType\":1},\"value\":\"0\",\"layerType\":\"text\",\"comp\":\"Text_11\",\"compId\":4249,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_12 - Text\",\"id\":4423,\"propertyType\":{\"type\":6,\"capPropType\":0},\"value\":\"specially for you\",\"layerType\":\"text\",\"comp\":\"Text_12\",\"compId\":4421,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_12 - Position\",\"id\":4423,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"872.26220703125,231.226165771484,0\",\"layerType\":\"text\",\"comp\":\"Text_12\",\"compId\":4421,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_12 - Size\",\"id\":4423,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"text\",\"comp\":\"Text_12\",\"compId\":4421,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_12 - Line Spacing\",\"id\":4423,\"propertyType\":{\"type\":2,\"capPropType\":1},\"value\":\"0\",\"layerType\":\"text\",\"comp\":\"Text_12\",\"compId\":4421,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_13 - Text\",\"id\":307,\"propertyType\":{\"type\":6,\"capPropType\":0},\"value\":\"Analyzes\",\"layerType\":\"text\",\"comp\":\"Text_13\",\"compId\":305,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_13 - Position\",\"id\":307,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"375.5,79.5,0\",\"layerType\":\"text\",\"comp\":\"Text_13\",\"compId\":305,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_13 - Size\",\"id\":307,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"text\",\"comp\":\"Text_13\",\"compId\":305,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_13 - Line Spacing\",\"id\":307,\"propertyType\":{\"type\":2,\"capPropType\":1},\"value\":\"0\",\"layerType\":\"text\",\"comp\":\"Text_13\",\"compId\":305,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_14 - Text\",\"id\":433,\"propertyType\":{\"type\":6,\"capPropType\":0},\"value\":\"Generates\",\"layerType\":\"text\",\"comp\":\"Text_14\",\"compId\":431,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_14 - Position\",\"id\":433,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"420.5,63.5,0\",\"layerType\":\"text\",\"comp\":\"Text_14\",\"compId\":431,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_14 - Size\",\"id\":433,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"text\",\"comp\":\"Text_14\",\"compId\":431,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_14 - Line Spacing\",\"id\":433,\"propertyType\":{\"type\":2,\"capPropType\":1},\"value\":\"0\",\"layerType\":\"text\",\"comp\":\"Text_14\",\"compId\":431,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_15 - Text\",\"id\":386,\"propertyType\":{\"type\":6,\"capPropType\":0},\"value\":\"Automate\",\"layerType\":\"text\",\"comp\":\"Text_15\",\"compId\":384,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_15 - Position\",\"id\":386,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"396,63,0\",\"layerType\":\"text\",\"comp\":\"Text_15\",\"compId\":384,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_15 - Size\",\"id\":386,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"text\",\"comp\":\"Text_15\",\"compId\":384,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_15 - Line Spacing\",\"id\":386,\"propertyType\":{\"type\":2,\"capPropType\":1},\"value\":\"0\",\"layerType\":\"text\",\"comp\":\"Text_15\",\"compId\":384,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_16 - Text\",\"id\":4226,\"propertyType\":{\"type\":6,\"capPropType\":0},\"value\":\"Optimize\",\"layerType\":\"text\",\"comp\":\"Text_16\",\"compId\":4224,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_16 - Position\",\"id\":4226,\"propertyType\":{\"type\":5,\"capPropType\":6},\"value\":\"360.5,81.5,0\",\"layerType\":\"text\",\"comp\":\"Text_16\",\"compId\":4224,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_16 - Size\",\"id\":4226,\"propertyType\":{\"type\":9,\"capPropType\":7},\"value\":\"100,100,100\",\"layerType\":\"text\",\"comp\":\"Text_16\",\"compId\":4224,\"parentFolder\":\"Text\",\"offline\":false},{\"name\":\"Text_16 - Line Spacing\",\"id\":4226,\"propertyType\":{\"type\":2,\"capPropType\":1},\"value\":\"0\",\"layerType\":\"text\",\"comp\":\"Text_16\",\"compId\":4224,\"parentFolder\":\"Text\",\"offline\":false}]}]"
const normalizeControllerName = (name) => (name ? String(name).trim() : "");

const isGlobalControllerName = (name) =>
  name === "Global Position" ||
  name === "Global Size" ||
  name === "Global Rotation";

const naturalSort = (a = "", b = "") => {
  const partsA = a.split(/(\d+)/);
  const partsB = b.split(/(\d+)/);

  for (let i = 0; i < Math.max(partsA.length, partsB.length); i += 1) {
    const partA = partsA[i] || "";
    const partB = partsB[i] || "";
    const numA = parseInt(partA, 10);
    const numB = parseInt(partB, 10);

    if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
      if (numA !== numB) return numA - numB;
    } else {
      const cmp = partA.toLowerCase().localeCompare(partB.toLowerCase());
      if (cmp !== 0) return cmp;
    }
  }
  return 0;
};

const createControllerNode = (controller) => ({
  id: uuidv4(),
  type: "item",
  name: controller.name,
  propertyType: controller.propertyType || {},
  value: controller.value,
  script: controller.script,
  path: controller.path,
  layerType: controller.layerType,
  comp: controller.comp,
  parentFolder: controller.parentFolder,
  offline: controller.offline,
});

const createGroupNode = (name, items = [], meta = {}) => ({
  id: uuidv4(),
  type: "group",
  name: name || "",
  items,
  expanded: true,
  meta,
});

const normalizeControllerPayload = (payload) => {
  let parsed = payload;
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch (error) {
      return [];
    }
  }
  if (parsed && !Array.isArray(parsed) && Array.isArray(parsed.comps)) {
    return parsed.comps;
  }
  if (Array.isArray(parsed) && parsed.length && parsed[0]?.controllers) {
    return parsed;
  }
  if (Array.isArray(parsed)) {
    return [
      {
        name: "CONTROLLERS",
        controllers: parsed,
      },
    ];
  }
  return [];
};

const sanitizeControllers = (controllers = []) => {
  if (!Array.isArray(controllers)) return [];
  return controllers
    .map((controller) => {
      if (!controller || controller.offline) return null;
      const trimmedName = normalizeControllerName(controller.name);
      if (!trimmedName) return null;
      return { ...controller, name: trimmedName };
    })
    .filter(Boolean);
};

const createFlatItems = (controllers = []) =>
  sanitizeControllers(controllers).map((controller) =>
    createControllerNode(controller),
  );

const flattenNodesToControllers = (nodes = []) => {
  const result = [];
  const visit = (list = []) => {
    list.forEach((node) => {
      if (!node) return;
      if (node.type === "item") {
        result.push({
          name: node.name,
          propertyType: node.propertyType,
          value: node.value,
          script: node.script,
          path: node.path,
          layerType: node.layerType,
          comp: node.comp,
          parentFolder: node.parentFolder,
          offline: node.offline,
        });
      } else if (node.type === "group" && node.items?.length) {
        visit(node.items);
      }
    });
  };
  visit(nodes);
  return result;
};

const flattenNodeIds = (nodes = []) => {
  const ids = [];
  const traverse = (list = []) => {
    list.forEach((node) => {
      if (!node) return;
      ids.push(node.id);
      if (node.type === "group" && node.items?.length) {
        traverse(node.items);
      }
    });
  };
  traverse(nodes);
  return ids;
};

const filterGroupableMetas = (nodes, metas) => {
  if (!Array.isArray(metas) || !metas.length) return [];
  const selectedSet = new Set(metas.map((meta) => meta.node.id));
  const cache = new Map();
  const getParentMeta = (node) => {
    if (!node || !node.id) return null;
    if (cache.has(node.id)) return cache.get(node.id);
    const meta = findNodeMeta(nodes, node.id, nodes, null);
    cache.set(node.id, meta);
    return meta;
  };
  return metas.filter((meta) => {
    let current = meta.parentNode;
    while (current) {
      if (selectedSet.has(current.id)) {
        return false;
      }
      current = getParentMeta(current)?.parentNode || null;
    }
    return true;
  });
};

const getNextGroupNameFromTree = () => "GROUP";

const CONTROL_AUTO_GROUP_THRESHOLD = 5;

const parseNameForControlGrouping = (name) => {
  const normalized = normalizeControllerName(name);
  const match = normalized.match(/^(.+?)(\s+)?(\d+)(?:\s+(.*))?$/);
  if (match) {
    const hasSeparator = Boolean(match[2]);
    const baseName = hasSeparator ? match[1].trim() : `${match[1]}${match[3]}`;
    const index = hasSeparator ? match[3].trim() : null;
    return {
      baseName,
      index,
      normalized,
    };
  }
  return { baseName: normalized, index: null, normalized };
};

const groupControlsByName = (nodes = []) => {
  if (!nodes.length) return [];
  const groups = new Map();
  const baseOrder = [];

  nodes.forEach((node) => {
    const { baseName, index, normalized } = parseNameForControlGrouping(
      node.name,
    );
    const key = baseName.toLowerCase();
    if (!groups.has(key)) {
      groups.set(key, { baseName, entries: [] });
      baseOrder.push(key);
    }
    groups.get(key).entries.push({ node, index, normalized });
  });

  const result = [];

  baseOrder.forEach((key) => {
    const { baseName, entries } = groups.get(key);
    if (!entries.length) return;

    if (entries.length === 1 && entries[0].index === null) {
      result.push(entries[0].node);
      return;
    }

    const innerSequence = [];
    const indexGroups = new Map();

    entries.forEach((entry) => {
      if (entry.index) {
        const label = `${baseName} ${entry.index}`;
        const mapKey = label.toLowerCase();
        if (!indexGroups.has(mapKey)) {
          indexGroups.set(mapKey, { label, nodes: [] });
          innerSequence.push({ type: "group", key: mapKey });
        }
        indexGroups.get(mapKey).nodes.push(entry.node);
        return;
      }
      innerSequence.push({ type: "node", node: entry.node });
    });

    const innerItems = [];
    innerSequence.forEach((item) => {
      if (item.type === "node") {
        innerItems.push(item.node);
        return;
      }
      const groupInfo = indexGroups.get(item.key);
      if (!groupInfo) return;
      if (groupInfo.nodes.length > 1) {
        innerItems.push(
          createGroupNode(groupInfo.label.toUpperCase(), groupInfo.nodes),
        );
      } else if (groupInfo.nodes.length === 1) {
        innerItems.push(groupInfo.nodes[0]);
      }
    });

    result.push(...innerItems);
  });

  return result;
};

const getNameTokens = (node) => {
  if (!node?.name) return [];
  return normalizeControllerName(node.name).split(/\s+/).filter(Boolean);
};

const trimTrailingNumericTokens = (tokens = []) => {
  const trimmed = [...tokens];
  while (trimmed.length && /^\d+$/.test(trimmed[trimmed.length - 1])) {
    trimmed.pop();
  }
  return trimmed;
};

const groupItemsBySuffix = (nodes = []) => {
  if (!nodes.length) return nodes;
  const candidateMap = new Map();

  nodes.forEach((node) => {
    if (!node || node.type !== "item") return;
    const tokens = getNameTokens(node);
    if (!tokens.length) return;
    const trimmedTokens = trimTrailingNumericTokens(tokens);
    if (trimmedTokens.length < 2) return;
    for (let len = Math.min(trimmedTokens.length, 3); len >= 2; len -= 1) {
      const suffixTokens = trimmedTokens.slice(-len);
      const key = suffixTokens.join(" ");
      if (!key) continue;
      const entry = candidateMap.get(key);
      if (entry) {
        entry.nodes.push(node);
      } else {
        candidateMap.set(key, { nodes: [node], length: len });
      }
    }
  });

  const groupedCandidates = Array.from(candidateMap.entries())
    .map(([key, entry]) => ({
      key,
      nodes: Array.from(new Map(entry.nodes.map((n) => [n.id, n])).values()),
      length: entry.length,
    }))
    .filter((candidate) => candidate.nodes.length > 1)
    .sort((a, b) => {
      if (b.length !== a.length) return b.length - a.length;
      return b.nodes.length - a.nodes.length;
    });

  const consumed = new Set();
  const groupStarts = new Map();

  groupedCandidates.forEach((candidate) => {
    const available = candidate.nodes.filter((node) => !consumed.has(node.id));
    if (available.length < 2) return;
    available.forEach((node) => consumed.add(node.id));
    groupStarts.set(
      available[0].id,
      createGroupNode(candidate.key.toUpperCase(), available),
    );
  });

  if (!groupStarts.size) return nodes;

  const result = [];

  nodes.forEach((node) => {
    if (!node) return;
    if (groupStarts.has(node.id)) {
      result.push(groupStarts.get(node.id));
    }
    if (node.type === "item" && consumed.has(node.id)) {
      return;
    }
    result.push(node);
  });

  return result;
};

const getCommonPrefixTokens = (lists = []) => {
  if (!lists.length) return [];
  const minLength = Math.min(...lists.map((tokens) => tokens.length));
  const prefix = [];
  for (let i = 0; i < minLength; i += 1) {
    const token = lists[0][i];
    if (lists.every((tokens) => tokens[i] === token)) {
      prefix.push(token);
    } else {
      break;
    }
  }
  return prefix;
};

const groupItemsByFirstToken = (nodes = []) => {
  if (!nodes.length) return nodes;
  const tokenData = new Map();

  nodes.forEach((node) => {
    if (!node || node.type !== "item") return;
    const tokens = getNameTokens(node);
    if (!tokens.length) return;
    const [token] = tokens;
    if (!token) return;
    const normalizedName = normalizeControllerName(node.name);
    const hasSlash = normalizedName.includes("/");
    const target = tokenData.get(token) || {
      entries: [],
      hasExactMatch: false,
      allContainSlash: true,
    };
    target.entries.push({ node, tokens });
    if (normalizedName === token) {
      target.hasExactMatch = true;
    }
    if (!hasSlash) {
      target.allContainSlash = false;
    }
    tokenData.set(token, target);
  });

  const tokensToGroup = Array.from(tokenData.entries())
    .filter(([, data]) => {
      if (data.entries.length <= 1) return false;
      return (
        data.entries.length > 2 || data.hasExactMatch || !data.allContainSlash
      );
    })
    .map(([token]) => token);
  if (!tokensToGroup.length) return nodes;

  const labelMap = new Map();
  tokensToGroup.forEach((token) => {
    const entries = tokenData.get(token)?.entries || [];
    const prefixTokens = getCommonPrefixTokens(
      entries.map((entry) => entry.tokens),
    );
    const labelTokens = prefixTokens.length > 1 ? prefixTokens : [token];
    labelMap.set(token, labelTokens.join(" ").toUpperCase());
  });

  const groupedTokens = new Set();
  const result = [];

  nodes.forEach((node) => {
    if (!node || node.type !== "item") {
      result.push(node);
      return;
    }
    const tokens = getNameTokens(node);
    const [token] = tokens;
    if (token && labelMap.has(token) && !groupedTokens.has(token)) {
      groupedTokens.add(token);
      const entries = tokenData.get(token)?.entries || [];
      result.push(
        createGroupNode(
          labelMap.get(token),
          entries.map((entry) => entry.node),
        ),
      );
      return;
    }
    if (token && labelMap.has(token) && groupedTokens.has(token)) {
      return;
    }
    result.push(node);
  });

  return result;
};

const buildInitialTree = (controllers = []) => {
  if (!Array.isArray(controllers)) return [];

  const globals = [];
  const controls = [];
  const textMap = new Map();
  const media = [];
  const misc = [];
  const sanitized = sanitizeControllers(controllers);

  sanitized.forEach((controller) => {
    const trimmedName = controller.name;
    const node = createControllerNode(controller);

    if (isGlobalControllerName(trimmedName)) {
      globals.push(node);
      return;
    }

    if (controller.layerType === "controls") {
      controls.push(node);
      return;
    }

    if (controller.layerType === "text") {
      const key = controller.comp || "TEXT";
      if (!textMap.has(key)) {
        textMap.set(key, []);
      }
      textMap.get(key).push(node);
      return;
    }

    if (controller.layerType === "media") {
      media.push(node);
      return;
    }

    misc.push(node);
  });

  const groups = [];

  if (globals.length) {
    groups.push(createGroupNode("GLOBAL CONTROLS", globals));
  }

  if (controls.length) {
    const shouldAutoGroup = controls.length > CONTROL_AUTO_GROUP_THRESHOLD;
    const controlItems = shouldAutoGroup
      ? groupControlsByName(controls)
      : controls;
    const suffixGroupedControls = shouldAutoGroup
      ? groupItemsBySuffix(controlItems)
      : controlItems;
    const groupedControls = shouldAutoGroup
      ? groupItemsByFirstToken(suffixGroupedControls)
      : controlItems;
    groups.push(createGroupNode("CONTROLS", groupedControls));
  }

  if (textMap.size) {
    const entries = Array.from(textMap.entries()).sort((a, b) =>
      naturalSort(a[0], b[0]),
    );
    if (entries.length === 1) {
      groups.push(createGroupNode("TEXT CONTROLS", entries[0][1]));
    } else {
      const nested = entries.map(([comp, items]) =>
        createGroupNode(comp.toUpperCase(), items),
      );
      groups.push(createGroupNode("TEXT CONTROLS", nested));
    }
  }

  if (media.length) {
    groups.push(createGroupNode("REPLACE MEDIA", media));
  }

  if (misc.length) {
    groups.push(createGroupNode("OTHER CONTROLS", misc));
  }

  return groups;
};

const cloneNodes = (nodes = []) =>
  nodes.map((node) =>
    node.type === "group"
      ? { ...node, items: cloneNodes(node.items || []) }
      : { ...node },
  );

const findNodeMeta = (nodes, id, parentItems = nodes, parentNode = null) => {
  if (!Array.isArray(nodes)) return null;
  for (let i = 0; i < nodes.length; i += 1) {
    const node = nodes[i];
    if (node.id === id) {
      return { node, parentItems, parentNode, index: i };
    }
    if (node.type === "group" && node.items?.length) {
      const result = findNodeMeta(node.items, id, node.items, node);
      if (result) return result;
    }
  }
  return null;
};

const isDescendant = (node, targetId) => {
  if (!node || node.type !== "group" || !node.items) return false;
  return node.items.some(
    (child) =>
      child.id === targetId ||
      (child.type === "group" && isDescendant(child, targetId)),
  );
};

const getNodeLabel = (node) =>
  node.type === "group"
    ? normalizeControllerName(node.name)
    : normalizeControllerName(node.name);

const serializeNodes = (nodes = []) =>
  nodes.reduce((acc, node) => {
    if (node.type === "group") {
      const entry = {
        name: normalizeControllerName(node.name).toUpperCase(),
        items: serializeNodes(node.items || []),
      };
      if (node.meta?.layerId) {
        entry.layerId = node.meta.layerId;
      }
      acc.push(entry);
      return acc;
    }
    const name = normalizeControllerName(node.name);
    if (name) acc.push(name);
    return acc;
  }, []);

const serializeGrouping = (nodes = []) => ({
  groups: nodes
    .filter((node) => node.type === "group")
    .map((group) => ({
      name: normalizeControllerName(group.name).toUpperCase(),
      items: serializeNodes(group.items || []),
    })),
});

const collectSelectionMeta = (nodes, ids) => {
  const metas = [];
  ids.forEach((id) => {
    const meta = findNodeMeta(nodes, id, nodes, null);
    if (meta) metas.push(meta);
  });
  return metas;
};

const setExpandedState = (nodes, expanded) =>
  nodes.map((node) =>
    node.type === "group"
      ? {
          ...node,
          expanded,
          items: setExpandedState(node.items || [], expanded),
        }
      : node,
  );

const collectNodeIds = (node) => {
  if (!node) return [];
  const stack = [node];
  const ids = [];
  while (stack.length) {
    const current = stack.pop();
    if (!current) continue;
    ids.push(current.id);
    if (current.type === "group" && current.items?.length) {
      current.items.forEach((child) => stack.push(child));
    }
  }
  return ids;
};

const fetchControllersFromHost = () =>
  new Promise((resolve) => {
    if (typeof window === "undefined" || !window.jsx) {
      resolve([]);
      return;
    }

    getCachedScript();

    window.jsx.evalScript(
      `run(getMogrtControllers({type:"selected comp"}));`,
      function (result) {
        if (!result || result === "undefined") {
          resolve([]);
          return;
        }
        try {
          resolve(JSON.parse(result));
        } catch (error) {
          console.error("Failed to parse mogrt data", error);
          resolve([]);
        }
      },
    );
  });

function DraggableGroup({
  item,
  id,
  moveItem,
  onSelect,
  selectedIds,
  toggleGroup,
  deleteGroup,
  updateGroupName,
  focusTargetId = null,
  depth = 0,
}) {
  const ref = useRef(null);
  const inputRef = useRef(null);
  const shouldFocusName = focusTargetId === id;
  const [, drop] = useDrop({
    accept: [DND_ITEM_TYPE, DND_GROUP_TYPE],
    hover(draggedItem, monitor) {
      if (!ref.current || draggedItem.id === id) return;
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      if (draggedItem.type === DND_ITEM_TYPE && item.expanded) {
        moveItem(draggedItem.selectedIds || draggedItem.id, id, "inside");
        return;
      }

      if (
        clientOffset.y <
        hoverBoundingRect.top + hoverBoundingRect.height / 3
      ) {
        moveItem(draggedItem.selectedIds || draggedItem.id, id, "before");
      } else if (
        clientOffset.y >
        hoverBoundingRect.bottom - hoverBoundingRect.height / 3
      ) {
        moveItem(draggedItem.selectedIds || draggedItem.id, id, "after");
      }
    },
  });

  const isSelected = selectedIds.includes(id);
  const hasChildren = Boolean(item.items && item.items.length);

  const [{ isDragging }, drag] = useDrag({
    type: DND_GROUP_TYPE,
    item: {
      id,
      type: DND_GROUP_TYPE,
      selectedIds: isSelected ? selectedIds : undefined,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging() && monitor.getItem().id === id,
    }),
  });

  useEffect(() => {
    if (shouldFocusName && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [shouldFocusName]);

  drag(drop(ref));

  return (
    <div
      className="template-editor__item-wrapper"
      style={{ marginLeft: depth * 16 }}
    >
      <div
        ref={ref}
        onClick={(e) => {
          e.stopPropagation();
          onSelect(id, e.shiftKey, e.ctrlKey || e.metaKey);
        }}
        className={[
          "template-editor__item",
          "template-editor__item--folder",
          isSelected ? "template-editor__item--selected" : "",
          !hasChildren ? "template-editor__item--empty" : "",
          item.expanded && hasChildren
            ? "template-editor__item--expanded"
            : "template-editor__item--collapsed",
        ]
          .filter(Boolean)
          .join(" ")}
        style={{
          opacity: isDragging ? 0.5 : 1,
          backgroundColor: isSelected ? "#1d1d1d" : undefined,
        }}
      >
        <div className="template-editor__item-main">
          <span className="template-editor__drag-handle">
            <i className="fa-solid fa-grip-vertical"></i>
          </span>
          <button
            type="button"
            className={[
              "template-editor__toggle",
              !hasChildren ? "template-editor__toggle--empty" : "",
              item.expanded && hasChildren
                ? "template-editor__toggle--open"
                : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={(e) => {
              e.stopPropagation();
              if (hasChildren) {
                toggleGroup(id);
              }
            }}
            disabled={!hasChildren}
          >
            <i className="fa-solid fa-chevron-right"></i>
          </button>
          <span className="template-editor__item-icon template-editor__item-icon--folder">
            <i className="fa-regular fa-folder"></i>
          </span>
          <input
            className="rename__input template-editor__input"
            value={item.name}
            onChange={(e) => updateGroupName(id, e.target.value)}
            onClick={(e) => e.stopPropagation()}
            ref={inputRef}
          />
        </div>
        <div className="template-editor__item-actions">
          <button
            type="button"
            className="template-editor__delete-button"
            onClick={(e) => {
              e.stopPropagation();
              deleteGroup(id);
            }}
            title="Delete group"
          >
            <i className="fa-regular fa-trash"></i>
          </button>
        </div>
      </div>
      {item.expanded && hasChildren && (
        <div className="template-editor__children">
          {item.items.map((child) => {
            if (child.type === "item") {
              return (
                <MogrtGroupItem
                  key={child.id}
                  item={child}
                  id={child.id}
                  moveItem={moveItem}
                  isSelected={selectedIds.includes(child.id)}
                  onSelect={onSelect}
                  selectedIds={selectedIds}
                  isInGroup
                  depth={depth + 1}
                  groupLabel={item.name}
                />
              );
            }
            return (
              <DraggableGroup
                key={child.id}
                item={child}
                id={child.id}
                moveItem={moveItem}
                onSelect={onSelect}
                selectedIds={selectedIds}
                toggleGroup={toggleGroup}
                deleteGroup={deleteGroup}
                updateGroupName={updateGroupName}
                focusTargetId={focusTargetId}
                depth={depth + 1}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

function TreeDropContainer({ items, moveItem, children }) {
  const containerRef = useRef(null);
  const [, drop] = useDrop({
    accept: [DND_ITEM_TYPE, DND_GROUP_TYPE],
    drop(draggedItem, monitor) {
      if (!containerRef.current || !monitor.isOver({ shallow: true })) return;
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      const rect = containerRef.current.getBoundingClientRect();
      const nearBottom = clientOffset.y > rect.bottom - 32;
      if (!nearBottom || !items.length) return;
      const lastNode = items[items.length - 1];
      if (!lastNode || lastNode.id === draggedItem.id) return;
      moveItem(draggedItem.selectedIds || draggedItem.id, lastNode.id, "after");
    },
  });
  drop(containerRef);

  return (
    <div ref={containerRef} className="mogrt-group__tree">
      {children}
    </div>
  );
}

const CreateGroup = forwardRef(function CreateGroup(props, ref) {
  const popupRef = useRef(null);
  const initialControllersRef = useRef([]);
  const [items, setItems] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [compositions, setCompositions] = useState([]);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lastSelectedId, setLastSelectedId] = useState(null);
  const [groupRenameTargetId, setGroupRenameTargetId] = useState(null);

  const handleCloseModal = useCallback(() => {
    setPopupVisible(false);
    setItems([]);
    setSelectedIds([]);
    setLastSelectedId(null);
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      open: () => setPopupVisible(true),
      close: handleCloseModal,
    }),
    [handleCloseModal],
  );

  useEffect(() => {
    setModalOpen(isPopupVisible);
  }, [isPopupVisible]);

  useEffect(() => {
    if (props.onPopupStateChange) {
      props.onPopupStateChange(isPopupVisible);
    }
  }, [isPopupVisible]);

  useEffect(() => {
    if (!groupRenameTargetId) return undefined;
    const timer = setTimeout(() => setGroupRenameTargetId(null), 0);
    return () => clearTimeout(timer);
  }, [groupRenameTargetId]);

  const loadControllers = useCallback(async () => {
    setLoading(true);
    try {
      const sourceData =
        process.env.NODE_ENV === "development"
          ? DEV_CONTROLLERS
          : await fetchControllersFromHost();
      const parsedComps = normalizeControllerPayload(sourceData);
      const sanitizedComps = parsedComps.map((comp, index) => ({
        name: comp?.name || `COMPOSITION ${index + 1}`,
        controllers: sanitizeControllers(comp?.controllers || []),
      }));
      const mergedControllers = sanitizedComps.flatMap(
        (comp) => comp.controllers,
      );
      initialControllersRef.current = mergedControllers;
      setCompositions(sanitizedComps);
      setItems(createFlatItems(mergedControllers));
      setSelectedIds([]);
      setLastSelectedId(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isPopupVisible) {
      loadControllers();
    }
  }, [isPopupVisible, loadControllers]);

  const canCreateGroup = useMemo(() => {
    if (!selectedIds.length) return false;
    const metas = collectSelectionMeta(items, selectedIds);
    if (!metas.length) return false;
    const filtered = filterGroupableMetas(items, metas);
    if (!filtered.length) return false;
    const parentItems = filtered[0].parentItems;
    if (!parentItems) return false;
    return filtered.every((meta) => meta.parentItems === parentItems);
  }, [selectedIds, items]);

  const moveItem = (dragIds, targetId, position) => {
    const normalizedIds = [];
    const seenIds = new Set();
    if (Array.isArray(dragIds)) {
      dragIds.forEach((id) => {
        if (id && !seenIds.has(id)) {
          seenIds.add(id);
          normalizedIds.push(id);
        }
      });
    } else if (dragIds) {
      normalizedIds.push(dragIds);
    }
    if (!normalizedIds.length) return;
    if (normalizedIds.length === 1 && normalizedIds[0] === targetId) return;

    setItems((prev) => {
      const tree = cloneNodes(prev);
      const targetMeta = findNodeMeta(tree, targetId, tree, null);
      if (!targetMeta) return prev;
      if (position === "inside" && targetMeta.node.type !== "group") {
        return prev;
      }

      const metas = [];
      normalizedIds.forEach((id) => {
        const meta = findNodeMeta(tree, id, tree, null);
        if (meta) metas.push(meta);
      });
      if (!metas.length) return prev;

      const selectionSet = new Set(metas.map((meta) => meta.node.id));
      if (selectionSet.has(targetMeta.node.id)) return prev;

      const metaCache = new Map();
      const getMetaByNode = (node) => {
        if (!node) return null;
        if (metaCache.has(node.id)) return metaCache.get(node.id);
        const found = findNodeMeta(tree, node.id, tree, null);
        metaCache.set(node.id, found);
        return found;
      };

      const topLevelMetas = metas.filter((meta) => {
        let current = meta.parentNode;
        while (current) {
          if (selectionSet.has(current.id)) {
            return false;
          }
          current = getMetaByNode(current)?.parentNode || null;
        }
        return true;
      });

      if (!topLevelMetas.length) return prev;

      for (const meta of topLevelMetas) {
        if (isDescendant(meta.node, targetMeta.node.id)) {
          return prev;
        }
      }

      const flatOrder = flattenNodeIds(tree);
      const metaMap = new Map(
        topLevelMetas.map((meta) => [meta.node.id, meta]),
      );
      const orderedMetas = flatOrder
        .filter((nodeId) => metaMap.has(nodeId))
        .map((nodeId) => metaMap.get(nodeId));

      if (!orderedMetas.length) return prev;

      const removalGroups = new Map();
      orderedMetas.forEach((meta) => {
        const group = removalGroups.get(meta.parentItems);
        if (group) {
          group.push(meta);
        } else {
          removalGroups.set(meta.parentItems, [meta]);
        }
      });

      removalGroups.forEach((group, parentItems) => {
        group
          .sort((a, b) => b.index - a.index)
          .forEach((meta) => {
            parentItems.splice(meta.index, 1);
          });
      });

      const nodesToInsert = orderedMetas.map((meta) => meta.node);
      const updatedTargetMeta = findNodeMeta(tree, targetId, tree, null);
      if (!updatedTargetMeta) return prev;

      if (position === "inside") {
        if (updatedTargetMeta.node.type !== "group") return prev;
        updatedTargetMeta.node.items = updatedTargetMeta.node.items || [];
        updatedTargetMeta.node.items.push(...nodesToInsert);
        return tree;
      }

      const targetArray = updatedTargetMeta.parentItems;
      let insertIndex =
        updatedTargetMeta.index + (position === "after" ? 1 : 0);
      targetArray.splice(insertIndex, 0, ...nodesToInsert);

      return tree;
    });
  };

  const toggleGroup = (groupId) => {
    setItems((prev) => {
      const tree = cloneNodes(prev);
      const meta = findNodeMeta(tree, groupId, tree, null);
      if (!meta || meta.node.type !== "group") return prev;
      meta.node.expanded = !meta.node.expanded;
      return tree;
    });
  };

  const deleteGroup = (groupId) => {
    let removedIds = [];
    setItems((prev) => {
      const tree = cloneNodes(prev);
      const meta = findNodeMeta(tree, groupId, tree, null);
      if (!meta || meta.node.type !== "group") return prev;
      removedIds = collectNodeIds(meta.node);
      const children = meta.node.items || [];
      meta.parentItems.splice(meta.index, 1, ...children);
      return tree;
    });
    if (removedIds.length) {
      setSelectedIds((prev) => prev.filter((id) => !removedIds.includes(id)));
      setLastSelectedId((prev) =>
        prev && removedIds.includes(prev) ? null : prev,
      );
    }
  };

  const updateGroupName = (groupId, value) => {
    setItems((prev) => {
      const tree = cloneNodes(prev);
      const meta = findNodeMeta(tree, groupId, tree, null);
      if (!meta || meta.node.type !== "group") return prev;
      meta.node.name = value;
      return tree;
    });
  };

  const handleSelect = useCallback(
    (id, isShiftPressed, isCtrlOrCmdPressed) => {
      setSelectedIds((prev) => {
        const order = flattenNodeIds(items);
        if (isShiftPressed && order.length) {
          const anchorCandidate =
            (lastSelectedId && order.includes(lastSelectedId)
              ? lastSelectedId
              : prev[prev.length - 1]) || order[0];
          const startIndex = order.indexOf(anchorCandidate);
          const endIndex = order.indexOf(id);
          if (startIndex !== -1 && endIndex !== -1) {
            const [from, to] =
              startIndex <= endIndex
                ? [startIndex, endIndex]
                : [endIndex, startIndex];
            const range = order.slice(from, to + 1);
            const baseSet = new Set(isCtrlOrCmdPressed ? prev : []);
            range.forEach((rangeId) => baseSet.add(rangeId));
            return Array.from(baseSet);
          }
        }

        if (isCtrlOrCmdPressed) {
          if (prev.includes(id)) {
            return prev.filter((itemId) => itemId !== id);
          }
          return [...prev, id];
        }

        return [id];
      });
      setLastSelectedId(id);
    },
    [items, lastSelectedId],
  );

  const groupSelectedItems = () => {
    if (!canCreateGroup) return;
    let createdGroupId = null;
    setItems((prev) => {
      const tree = cloneNodes(prev);
      const metas = collectSelectionMeta(tree, selectedIds);
      if (!metas.length) return prev;
      const filtered = filterGroupableMetas(tree, metas);
      if (!filtered.length) return prev;
      const parentItems = filtered[0].parentItems;
      if (!parentItems) return prev;
      if (!filtered.every((meta) => meta.parentItems === parentItems))
        return prev;

      const ordered = [...filtered].sort((a, b) => a.index - b.index);
      const children = ordered.map((meta) => meta.node);
      for (let i = ordered.length - 1; i >= 0; i -= 1) {
        parentItems.splice(ordered[i].index, 1);
      }

      const nextGroupName = getNextGroupNameFromTree(tree);
      const newGroup = createGroupNode(nextGroupName, children);
      createdGroupId = newGroup.id;
      parentItems.splice(ordered[0].index, 0, newGroup);
      return tree;
    });

    if (createdGroupId) {
      setSelectedIds([createdGroupId]);
      setLastSelectedId(createdGroupId);
      setGroupRenameTargetId(createdGroupId);
    }
  };

  const handleExpandCollapse = (expand) => {
    setItems((prev) => setExpandedState(prev, expand));
  };

  const handleAutoGroup = () => {
    setItems((prev) => {
      const grouped = buildInitialTree(flattenNodesToControllers(prev));
      return setExpandedState(grouped, false);
    });
    setSelectedIds([]);
    setLastSelectedId(null);
  };

  const handleClearGrouping = () => {
    const baseControllers =
      initialControllersRef.current.length > 0
        ? initialControllersRef.current
        : flattenNodesToControllers(items);
    setItems(createFlatItems(baseControllers));
    setSelectedIds([]);
    setLastSelectedId(null);
  };

  const previewStructure = useMemo(() => cloneNodes(items), [items]);

  const groupingPreview = useMemo(() => {
    const formatted = serializeGrouping(previewStructure);
    if (!compositions.length) {
      return JSON.stringify([], null, 2);
    }
    const payload = compositions.map((comp) => ({
      name: comp.name,
      controllers: comp.controllers,
      grouping: formatted,
    }));
    return JSON.stringify(payload, null, 2);
  }, [previewStructure, compositions]);

  const handleSaveGrouping = () => {
    handleClick("autoGroupMogrt", groupingPreview);
    handleCloseModal();
  };

  if (props.selectedTag && props.selectedTag !== props.buttonTags) {
    return null;
  }

  return (
    <>
      {isPopupVisible && (
        <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
          <div
            ref={popupRef}
            className="mogrt-group__popup"
            onClick={(e) => {
              if (e.target === popupRef.current) {
                setSelectedIds([]);
                setLastSelectedId(null);
              }
            }}
          >
            <div className="mogrt-group__nav">
              <div
                className={`mogrt-group__nav-item ${!canCreateGroup ? "disabled" : ""}`}
                onClick={groupSelectedItems}
                title="Add Group"
              >
                <i className="fa-regular fa-folder-plus"></i>
                <span className="render-group__button-text">Add Group</span>
              </div>
              <div
                className="mogrt-group__nav-item"
                onClick={handleAutoGroup}
                title="Auto Group"
              >
                <i className="fa-regular fa-bars-sort"></i>
                <span className="render-group__button-text">Auto Group</span>
              </div>
              <div
                className="mogrt-group__nav-item"
                onClick={() => handleExpandCollapse(true)}
                title="Open Groups"
              >
                <i className="fa-regular fa-toggle-on"></i>
                <span className="render-group__button-text">Open Groups</span>
              </div>
              <div
                className="mogrt-group__nav-item"
                onClick={() => handleExpandCollapse(false)}
                title="Close Groups"
              >
                <i className="fa-solid fa-toggle-off"></i>
                <span className="render-group__button-text">Close Groups</span>
              </div>
              <div
                className="mogrt-group__nav-item"
                onClick={handleClearGrouping}
                title="Delete Groups"
              >
                <i className="fa-regular fa-trash-can"></i>
                <span className="render-group__button-text">Delete Groups</span>
              </div>
              <div
                className="mogrt-group__nav-item"
                onClick={handleSaveGrouping}
                title="Save"
              >
                <i className="fa-regular fa-floppy-disk"></i>
                <span className="render-group__button-text">Save</span>
              </div>
              <div
                className="mogrt-group__popup-close mogrt-group__nav-item"
                onClick={handleCloseModal}
                title="Close"
              >
                <i className="fa-regular fa-circle-xmark"></i>
                <span className="render-group__button-text">Close</span>
              </div>
            </div>

            <DndProvider backend={HTML5Backend}>
              {loading ? (
                <div className="mogrt-group__empty">Loading controllers?</div>
              ) : items.length === 0 ? (
                <div className="mogrt-group__empty">No controllers found.</div>
              ) : (
                <TreeDropContainer items={items} moveItem={moveItem}>
                  {items.map((item) => {
                    if (item.type === "group") {
                      return (
                        <DraggableGroup
                          key={item.id}
                          item={item}
                          id={item.id}
                          moveItem={moveItem}
                          onSelect={handleSelect}
                          selectedIds={selectedIds}
                          toggleGroup={toggleGroup}
                          deleteGroup={deleteGroup}
                          updateGroupName={updateGroupName}
                          focusTargetId={groupRenameTargetId}
                          depth={0}
                        />
                      );
                    }
                    return (
                      <MogrtGroupItem
                        key={item.id}
                        item={item}
                        id={item.id}
                        moveItem={moveItem}
                        isSelected={selectedIds.includes(item.id)}
                        selectedIds={selectedIds}
                        onSelect={handleSelect}
                        isInGroup={false}
                        depth={0}
                      />
                    );
                  })}
                </TreeDropContainer>
              )}
            </DndProvider>
          </div>
        </Modal>
      )}
    </>
  );
});

export default CreateGroup;
